export const LIST_FILTER_TYPE = 'list';
export const VEHICLE_FILTER_TYPE = 'vehicle';
export const VCDB_FILTER_TYPE = 'vcdb';
export const SIMPLE_FILTER_TYPE = 'simple';
export const PART_ATTRIBUTES_FILTER_TYPE = 'partAttributes';
export const ARRAY_FILTER_TYPE = 'array';
// User attributes - PAdb/Custom https://speedlab.atlassian.net/browse/SPD2-4299
export const PADB_FILTER_TYPE = 'padb';
export const CUSTOM_FILTER_TYPE = 'custom';
